import { Box } from "@mui/material";
import PersistentDrawerLeft from "./PersistentDrawerLeft";
import { ERole, IApplicationState } from "../../../store-redux";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ROUTES } from "../../../constants";
// import { useCheckPersonalized } from "@/hook/useCheckPersonalized";

interface IDefaultLayoutProps {
  children: JSX.Element;
}

function DefaultLayout({ children }: IDefaultLayoutProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const currentInfoUser = useSelector((state: IApplicationState) => state.currentUser);
  const appMode = useSelector((state: IApplicationState) => state.appMode);
  const isDark = appMode === "dark";

  useEffect(() => {
    if (currentInfoUser.data) {
      const isAdmin = currentInfoUser.data?.role === ERole.ADMIN || currentInfoUser.data?.role === ERole.SUPER_ADMIN;
      const isReviewRoute = pathname.startsWith("/ielts-exams/review");
      if (isAdmin && !isReviewRoute) {
        navigate(ROUTES.LOGIN);
      }
    }
  }, [currentInfoUser.data, pathname, navigate]);

  return (
    <Box
      className="default-layout-view"
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        bgcolor: isDark ? "#020617" : "#F8FAFC",
        position: "relative",
        transition: "background-color 0.3s ease",
      }}
    >
      {/* Ambient Glows */}
      <Box
        sx={{
          position: "fixed",
          top: "10%",
          right: "-5%",
          width: "40%",
          height: "40%",
          background: isDark
            ? "radial-gradient(circle, rgba(99, 102, 241, 0.08) 0%, transparent 70%)"
            : "radial-gradient(circle, rgba(99, 102, 241, 0.05) 0%, transparent 70%)",
          filter: "blur(80px)",
          zIndex: 0,
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "fixed",
          bottom: "10%",
          left: "-5%",
          width: "40%",
          height: "40%",
          background: isDark
            ? "radial-gradient(circle, rgba(45, 212, 191, 0.08) 0%, transparent 70%)"
            : "radial-gradient(circle, rgba(45, 212, 191, 0.05) 0%, transparent 70%)",
          filter: "blur(80px)",
          zIndex: 0,
          pointerEvents: "none",
        }}
      />

      <Box sx={{ flex: 1, overflowY: "auto", position: "relative", zIndex: 1 }}>
        <PersistentDrawerLeft>{children}</PersistentDrawerLeft>
      </Box>
    </Box>
  );
}

export default DefaultLayout;
